import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { invitationMutations } from "@surgia/api/src/queryStore/hub/invitation";
import { SendInvitationParams } from "@surgia/api/src/hub/invitation";

export const useSendInvitation = () => {
  const queryClient = useQueryClient();

  const sendInvitationMutation = useMutation({
    mutationFn: (params: SendInvitationParams) =>
      invitationMutations.sendInvitation().mutationFn(params),
    onSuccess: () => {
      toast.success("User invitation sent successfully!");
      // Invalidate and refetch users data
      queryClient.invalidateQueries({ queryKey: ["shared", "users"] });
    },
    onError: (error: any) => {
      if (error?.response?.data?.exceptionResponse?.errorCode == "SS-021") {
        toast.error("User already exists");
      } else {
        toast.error("Failed to send invitation");
      }
    },
  });

  const sendInvitation = (params: SendInvitationParams) => {
    sendInvitationMutation.mutate(params);
  };

  return {
    sendInvitation,
    isPending: sendInvitationMutation.isPending,
    isError: sendInvitationMutation.isError,
    error: sendInvitationMutation.error,
    reset: sendInvitationMutation.reset,
  };
};
